import {
    createInfiniteQueryOptions,
    createMutationOptions,
    redirectOnStatusCode,
    setTenantHeaderMiddleware,
    tenantIdStorage,
    throwOnErrorResponse
} from "@sg-protect/core";
import config from "@sg-protect/runtime-config";
import createFetchClient from "openapi-fetch";
import createQueryClient from "openapi-react-query";
import type { paths } from "./types.ts";

export const client = createFetchClient<paths>({
    baseUrl: config.get().insights.api,
    credentials: "include",
    fetch: (...args) => globalThis.fetch(...args) // Ensure that fetch is resolved at request time for Honeycomb instrumentation to work correctly
});

client.use(throwOnErrorResponse());

client.use(setTenantHeaderMiddleware(tenantIdStorage.get));

client.use(
    redirectOnStatusCode({
        status: 401,
        to: () => `${config.get().insights.login}?returnUrl=${encodeURIComponent(window.location.href)}`
    })
);

export const { queryOptions, useQuery, useSuspenseQuery } = createQueryClient(client);

export const mutationOptions = createMutationOptions(client);

export const infiniteQueryOptions = createInfiniteQueryOptions(client, { staleTime: 5 * 60 * 1000 });
